import { render } from "./LockScreenPage.vue?vue&type=template&id=17e4815a&ts=true"
import script from "./LockScreenPage.vue?vue&type=script&lang=ts"
export * from "./LockScreenPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__